import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcCommentShape, userIdentityShape, catalogBibShape, ugcRatingShape } from '@bibliocommons/bc-prop-types';
import { selectCurrentUserRatings } from 'app/selectors/ugc/RatingsSelector';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentUserLikes } from 'app/selectors/ugc/LikesSelector';
import ModalActions from 'app/actions/ModalActions';
import LikesActions from 'app/actions/LikesActions';

import CommentDisplay from './CommentDisplay';

export class CommentDisplayContainer extends React.PureComponent {
  render() {
    return <CommentDisplay {...this.props} />;
  }
}

CommentDisplayContainer.propTypes = {
  // ownProps
  comment: ugcCommentShape.isRequired,
  displayStaffBadge: PropTypes.bool,
  catalogBib: catalogBibShape.isRequired,
  handleDeleteSuccess: PropTypes.func,

  // Redux props
  users: ImmutablePropTypes.mapOf(userIdentityShape).isRequired,
  currentUserLikes: ImmutablePropTypes.mapOf(ImmutablePropTypes.map).isRequired,
  currentUserRating: ugcRatingShape,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  likesActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    users: selectUserEntities(state),
    currentUserRating: selectCurrentUserRatings(state).get(ownProps.catalogBib.get('metadataId')),
    currentUserLikes: selectCurrentUserLikes(state)
  };
};

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch),
  likesActions: bindActionCreators(LikesActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentDisplayContainer);
